import { HsmWebsite, LIMIT_TIER } from '@/services/hsm-backend/types';
import { HsmBackendResponse } from '@/utils/http-client';

export enum AsyncThunkStatus {
  idle = 'idle',
  pending = 'pending',
  succeeded = 'succeeded',
  failed = 'failed',
}

export type ASYNC_ACTION_STATUS_TYPE = AsyncThunkStatus[keyof AsyncThunkStatus];

export type HSM_BACKEND_REJECT_VALUE_TYPE = HsmBackendResponse<unknown>;
export interface CommonState {
  company: string;
  currentChannel: HsmWebsite['id'];
  channelsLoaded: boolean;
  tierCurrentLimit: Nullable<LIMIT_TIER>;
  fetchAccountLimitStatus: ASYNC_ACTION_STATUS_TYPE;
}
